import { ROUTES } from '../../../module/constants'

const SECTION_BASE_URL = ROUTES.TECHNICAL_USERS

export const TECHNICAL_USER_ROUTES_URL = {
  STEP_ONE: SECTION_BASE_URL,
  STEP_TWO: `${SECTION_BASE_URL}/step-two`,
  STEP_THREE: `${SECTION_BASE_URL}/step-three`,
  CREATE_STEP_ZERO: `${SECTION_BASE_URL}/create-step-zero`,
  CREATE_STEP_ONE: `${SECTION_BASE_URL}/create-step-one`,
  CREATE_STEP_TWO: `${SECTION_BASE_URL}/create-step-two`,
  CREATE_STEP_THREE: `${SECTION_BASE_URL}/create-step-three`,
}

export const STATE_IDENTIFIER = {
  SELECTED_USER_TYPE: 'selectedUserType',
  SELECTED_OU: 'selectedOu',
  SELECTED_OU_NAME: 'selectedOuName',
  SELECTED_ACCOUNT: 'selectedAccount',
  SELECTED_TU: 'selectedTechnicalUser',
  STEP_ONE: 'stepOne',
  STEP_ONE_OUS: 'ous',
  STEP_ONE_LOADER: 'loader',
  STEP_TWO: 'stepTwo',
  STEP_TWO_ACCOUNTS: 'accounts',
  STEP_TWO_LOADER: 'loader',
  STEP_THREE: 'stepThree',
  STEP_THREE_PWD_POLICY: 'passwordPolicy',
  STEP_THREE_CALL_STATE: 'callState',
  CREATION: 'creation',
  TU_APPLICATION: 'technicalUserApplication',
  APPLICATIONS: 'applications',
  TU_DESCRIPTION: 'technicalUserDescription',
  TU_ROBOT_USER_NUMBER: 'robotUserNumber',
  TU_ROBOT_APPLICATIONS: 'robotApplications',
  IS_EDITING: 'isEditing',
  CATALOG_ENTITLEMENTS: 'catalogEntitlements',
  CATALOG_ENTITLEMENTS_LOADER: 'catalogEntitlementsLoader',
  TU_ENTITLEMENTS: 'technicalUserEntitlements',
  TU_ENTITLEMENTS_LOADER: 'technicalUserEntitlementsLoader',
  ADDED_ENTITLEMENTS: 'addedEntitlements',
  DELETED_ENTITLEMENTS: 'deletedEntitlements',
  CREATION_CALL_STATE: 'creationCallState',
  CALL_STATE: 'callState',
}

// Define the technical user types
export const TECHNICAL_USERS_ROBOT = 'robotuser' as const
export const TECHNICAL_USERS_SERVICE = 'serviceuser' as const
export type TechnicalUserType =
  | typeof TECHNICAL_USERS_ROBOT
  | typeof TECHNICAL_USERS_SERVICE
